<template>
  <div class="wrapper">
    <v-container class="px-12" fluid >
      <v-row >
        <v-col cols="12" class="sub-headline ml-1">
          Tribes
        </v-col >

        <v-col
          v-for="tribe in tribes"
          :key="tribe.id"
          justify-self="start"
          cols="auto"
        >
          <CommunityCard
            :community="tribe"
            @click="goToTribeRegistration(tribe.id)"
          />
        </v-col>
      </v-row>
    </v-container>

    <Snackbar
      v-if="snackbar"
      :show="snackbar"
      :message="snackbarMsg"
      @clearSnackbar="clearSnackbar"
    />
  </div>
</template>

<script>
import gql from 'graphql-tag'

import CommunityCard from '@/components/community/CommunityCard.vue'
import Snackbar from '@/components/Snackbar'

const SECONDS = 1000

export default {
  name: 'Dashboard',
  data: () => ({
    errorMsg: null,
    checkingPort: null,
    tribes: [],
    snackbar: false,
    snackbarMsg: ''
  }),
  apollo: {
    tribes: {
      query: gql`query {
        tribes {
          id
          public {
            preferredName
            description
            avatarImage {
              uri
            }
          }
        }
      }`,
      fetchPolicy: 'no-cache',
      update (data) {
        return data.tribes
          // .filter(tribe => tribe.public && tribe.public[0])
          // TODO check why this api is returning tribes with no public profiles?
          .map(tribe => {
            return {
              id: tribe.id,
              ...tribe.public[0]
            }
          })
      },
      pollInterval: 10 * SECONDS
    }
  },
  watch: {
    tribes (next, prev) {
      if (next && next.length === 1) {
        this.goToTribeRegistration(next[0].id)
      }
    }
  },
  methods: {
    goToTribeRegistration (tribeId) {
      this.$router.push({
        name: 'registrationNew',
        params: {
          tribeId
        }
      })
    },
    showSnackbar (msg) {
      this.snackbarMsg = msg
      this.snackbar = true
    },
    clearSnackbar () {
      this.snackbarMsg = ''
      this.snackbar = false
    }
  },
  components: {
    CommunityCard,
    Snackbar
  }
}
</script>

<style scoped lang="scss">
.wrapper {
  // background-color: white;
  width: 100%;
  height: 100%;
  max-width: 1600px;
  margin: 0 auto;
}
.generated-code {
  min-height: 70px;
}
.overflow-wrap {
  overflow-wrap: break-word;
  width: 80%;
  margin: 10px auto;
}
.dot {
  height: 15px;
  width: 15px;
  background-color: grey;
  border-radius: 50%;
  display: inline-block;
}
.green {
  background-color: rgb(74, 164, 121);
}
.orange {
  background-color: rgb(201, 158, 79);
}
.red {
  background-color: rgb(165, 50, 50);
}
.grey {
  background-color: grey;
}
h1 {
  font-size: 1.5em;
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 5px;
}
h2 {
  font-size: 1em;
  text-transform: uppercase;
  font-weight: 400;
  letter-spacing: 4px;
}

</style>
